let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4pZBy")).then(() => parcelRequire('chwK5'));